export const createConfirmAction = (pendingConfirmationAction, message, param) => {
    return {
        type: 'REQUEST_CONFIRMATION',
        pendingConfirmationAction,
        message,
        param
    };
};

export const cancelConfirmation = () => {
    return {
        type: 'CANCEL',
    };
};

export const confirmPendingAction = () => {
    return (dispatch, getState) => {
        const cancelConfirmationAction = cancelConfirmation();

        if(getState().confirm.pendingConfirmationAction) {
            const pendingConfirmAction = getState().confirm.pendingConfirmationAction;
            const param = getState().confirm.param;

            if(!param) {
                dispatch(pendingConfirmAction);
            } else {
                pendingConfirmAction(param);
            }

            dispatch(cancelConfirmationAction);
        } else {
            dispatch(cancelConfirmationAction);
        }
    };
};